import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import { whatsAppHref } from '../constants/conversion';

export default function PageSalesCta() {
  return (
    <Box
      component="section"
      sx={{
        py: { xs: 5, md: 6 },
        px: 2,
        background: 'linear-gradient(135deg, #1D1D4E 0%, #2a2a6e 100%)',
        color: 'white',
        textAlign: 'center',
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 800, mb: 1.5 }}>
        Ready to turn this into a project?
      </Typography>
      <Typography variant="body1" sx={{ mb: 3, opacity: 0.92, maxWidth: 560, mx: 'auto', lineHeight: 1.65 }}>
        Send a short brief — we reply fast with next steps, ballpark, and a call time. Same team builds software, AI,
        automation, and campaign systems for Kenya and East Africa.
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center" alignItems="center">
        <Button
          component={Link}
          to="/request-quote"
          variant="contained"
          color="secondary"
          size="large"
          sx={{ fontWeight: 700, minWidth: 220 }}
        >
          Get a free project scope
        </Button>
        <Button
          component="a"
          href={whatsAppHref('Hi Boldcomp — I want to discuss a project or course.')}
          target="_blank"
          rel="noopener noreferrer"
          variant="outlined"
          size="large"
          sx={{ borderColor: 'rgba(255,255,255,0.85)', color: 'white', fontWeight: 700, minWidth: 200, '&:hover': { borderColor: 'white', bgcolor: 'rgba(255,255,255,0.08)' } }}
        >
          WhatsApp us now
        </Button>
        <Button component={Link} to="/courses" variant="text" sx={{ color: 'rgba(255,255,255,0.9)', fontWeight: 600 }}>
          View courses
        </Button>
      </Stack>
    </Box>
  );
}
